import { Smartphone } from "lucide-react";
import { waLink } from "@/lib/store";
import { Reveal, Eyebrow } from "./Reveal";

const SoldCard = ({ p, i }) => (
  <Reveal delay={(i % 6) * 0.06} data-testid={`sold-card-${p.id}`} className="group">
    <div className="relative aspect-[4/5] overflow-hidden rounded-[20px] border border-white/10 bg-zinc-950">
      {p?.images?.[0] ? (
        <img src={p.images[0]} alt={p.model} loading="lazy" className="h-full w-full object-cover grayscale opacity-60 transition-transform duration-[1200ms] group-hover:scale-105" />
      ) : (
        <Smartphone className="absolute inset-0 m-auto h-10 w-10 text-zinc-600" />
      )}
      <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 -rotate-12 rounded-md border-2 border-white px-3 py-1 font-display text-lg font-extrabold uppercase tracking-[0.2em] text-white">
        Vendido
      </span>
    </div>
    <p className="mt-3 font-display text-base font-bold text-white">{p.model}</p>
    <p className="text-sm text-zinc-400">{[p.storage, p.color].filter(Boolean).join(" · ")}</p>
  </Reveal>
);

export const SoldShowcase = ({ items }) => {
  if (!Array.isArray(items) || !items.length) return null;
  return (
    <section data-testid="sold-section" className="mx-auto max-w-[1440px] px-5 sm:px-8 pb-24 sm:pb-36">
      <Reveal className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <Eyebrow>Saíram da vitrine</Eyebrow>
          <h2 className="font-display mt-4 text-4xl sm:text-5xl font-extrabold tracking-[-0.04em] text-white">
            Vendidos <span className="text-outline">recentemente.</span>
          </h2>
        </div>
        <a data-testid="sold-similar-whatsapp" href={waLink("Olá, RC iPhones! Vi que um aparelho já foi vendido. Vocês têm algum parecido?")} target="_blank" rel="noopener noreferrer"
          className="link-underline w-fit text-sm font-semibold text-white">
          Perdeu algum? Peça um parecido no WhatsApp →
        </a>
      </Reveal>
      <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
        {items.map((p, i) => <SoldCard key={p.id} p={p} i={i} />)}
      </div>
    </section>
  );
};
